import React, { FC, PropsWithChildren } from 'react';

import { useTimer } from '../../hooks/use-timer.hook';

import styles from './Timer.module.scss';

export interface ISimpleTimerProps {
    minutes: number;
    seconds: number;
    setMinutes: (minutes: number) => void;
    setSeconds: (seconds: number) => void;
    endOfTimerHandler: () => void;
}

export const SimpleTimer = (props: ISimpleTimerProps) => {
    const {
        minutes,
        seconds,
        setMinutes,
        setSeconds,
        endOfTimerHandler,
    } = props;

    const { renderMinutes, renderSeconds } = useTimer({minutes, seconds, setMinutes, setSeconds, endOfTimerHandler});

    return (
        <span>
            {`${renderMinutes}:${renderSeconds}`}
        </span>
    );
};

export const BlockTimerWrapper = ({ children }: PropsWithChildren) => (
    <div className={styles.timerWrapper}>
        {children}
    </div>
);

export interface ISingleTimerBlock {
    renderTimeUnit: string;
    title?: string;
}

export const SingleTimerBlock: FC<ISingleTimerBlock> = ({ renderTimeUnit, title}) => (
    <div className={styles.timerBlock}>
        <span>
            {renderTimeUnit}
        </span>
        {title && <span>{title}</span>}
    </div>
);

export interface IBlockTimerProps extends ISimpleTimerProps {
    minutesTitle?: string;
    secondsTitle?: string;
}

export const BlockTimer = (props: IBlockTimerProps) => {
    const { minutes, seconds, secondsTitle, minutesTitle, setMinutes, setSeconds, endOfTimerHandler } = props;

    const { renderMinutes, renderSeconds } = useTimer({
        minutes,
        seconds,
        setMinutes,
        setSeconds,
        endOfTimerHandler
    });

    return (
        <BlockTimerWrapper>
            <SingleTimerBlock renderTimeUnit={renderMinutes} title={minutesTitle} />
            <SingleTimerBlock renderTimeUnit={renderSeconds} title={secondsTitle} />
        </BlockTimerWrapper>
    );
};

